import { useForm } from '@/Components/formik-steps'
import debounce from 'lodash.debounce'
import { useCallback, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Loader from '@/Components/Loader'

export default function LicensePlate({
    countryCode,
    height
}) {
    const { values, setFieldValue } = useForm()

    const [loading, setLoading] = useState(false)

    const inputRef = useRef(null)

      // eslint-disable-next-line
    const search = useCallback(debounce((value) => {
        setLoading(true)
        axios.get('https://opendata.rdw.nl/resource/m9d7-ebf2.json?kenteken=' + value).then(({ data }) => {
            if (data.length > 0) {
                const result = data[0]
                setFieldValue('license_found', true)
                setFieldValue('brand', result.merk)
                setFieldValue('build', result.handelsbenaming)
            
                setFieldValue('errors', [])
         
                return
            }

            setFieldValue('brand', '')
            setFieldValue('build', '')
            setFieldValue('license_found', false)
            setFieldValue('errors', [
                <span className="block mt-2 text-red-500">Geen auto gevonden met dit kenteken</span>
            ])
        }).finally(() => {
            setTimeout(() => {
                setLoading(false)
            }, 500)
        })
    }, 300), []);

    useEffect(() => {
        if (!loading) {
            inputRef.current.focus()
        }
    }, [loading])

    if (loading) {
        return <Loader />
    }

    return (
        <div className='inline-flex flex-col'>
         <div
  className={`w-full rounded-xl flex overflow-hidden`}
  style={{
    height: `${height}px`,
    width: `375px`,
  }}
>
                <div className="w-[40px] bg-blue-500 shrink-0">
                    <div className="h-1/2 flex justify-center items-center">
                        <div className="">
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/9/93/European_stars.svg"
                                alt="Stars of european flag"
                                className="w-[30px] pt-1"
                            />
                        </div>
                    </div>
                    <div className="h-1/2 flex justify-center items-center">
                        <h1
                            className={`font-bold text-lg text-white`}>
                            {countryCode.substring(0, 3)}
                        </h1>
                    </div>
                </div>
                <div className="inline-flex items-center justify-center flex-grow bg-yellow-500">
                    <input
                        type="text"
                        ref={inputRef}
                        value={values.license}
                        onChange={e => {
                            const inputValue = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 7)
                            setFieldValue('license', inputValue)

                            if (inputValue.length >= 6) {
                                search(inputValue)
                            }
                        }}
                        placeholder="ABC123"
                        maxLength={6}
                        className="placeholder-gray-600 bg-yellow-500 text-black px-2 py-1 max-w-[100%] text-center outline-none focus:border-none border-none text-xl tracking-[8px]"
                    />
                </div>
            </div>
        </div>
    )
}